import { FlagsRepository } from '../repositories/flagsRepository'

export function ListFlagsCase(repository: FlagsRepository) {
  return async function () {
    return await repository.listFlags()
  }
}
